/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconKeyframeAlignVerticalFilled = createReactComponent("filled", "keyframe-align-vertical-filled", "IconKeyframeAlignVerticalFilled", [["path", { "d": "M12 1a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-0" }], ["path", { "d": "M12 6c-.629 0 -1.214 .301 -1.606 .807l-2.908 3.748a2.395 2.395 0 0 0 -.011 2.876l2.919 3.762c.39 .505 .977 .807 1.606 .807c.629 0 1.214 -.301 1.606 -.807l2.908 -3.748a2.395 2.395 0 0 0 .011 -2.876l-2.919 -3.762a2.032 2.032 0 0 0 -1.606 -.807z", "key": "svg-1" }], ["path", { "d": "M12 19a1 1 0 0 1 .993 .883l.007 .117v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2a1 1 0 0 1 1 -1z", "key": "svg-2" }]]);

export { IconKeyframeAlignVerticalFilled as default };
//# sourceMappingURL=IconKeyframeAlignVerticalFilled.mjs.map
